type ChallengeSeason = 'autumn' | 'spring';

function getSeason(startingDate: string): ChallengeSeason {
  const date = new Date(startingDate);
  const month = date.getMonth() + 1;
  if (month >= 1 && month <= 6) {
    return 'spring';
  } else if (month >= 9 && month <= 12) {
    return 'autumn';
  } else {
    return 'autumn';
  }
}

function getChallengeYear(date: string): string {
  const dateObject = new Date(date);
  return dateObject.getFullYear().toString();
}

export const CHALLENGE_STARTING_DATE =
  process.env.REACT_APP_CHALLENGE_START_DATE || '2024-09-05';

export const CHALLENGE_ENDING_DATE =
  process.env.REACT_APP_CHALLENGE_END_DATE || '2024-12-05';

export const CURRENT_CHALLENGE_SEASON: ChallengeSeason = getSeason(
  CHALLENGE_STARTING_DATE
);

export const CURRENT_CHALLENGE_YEAR: string = getChallengeYear(
  CHALLENGE_STARTING_DATE
);
